<script lang="ts" setup>
interface FilterOption {
  key?: string
  active?: boolean
  children?: FilterOption[]
  [key: string]: unknown
}

interface Filter {
  options: FilterOption[]
  [key: string]: unknown
}

const { t: $t } = useI18n()

const props = defineProps<{
  filter: Filter
}>()

const meta = inject('meta', ref())

const rootCategoryId = computed<string | null>(() => {
  return meta.value?.filters?.find((item: any) => item.key === 'category')?.values?.[0] as string || null
})

const getDeepestActiveOptions = (options: FilterOption[]): FilterOption[] => {
  if (!rootCategoryId.value) {
    return options
  }
  const rootOption = options.find((item: FilterOption) => item.key === rootCategoryId.value)
  if (rootOption && rootOption.children?.length) {
    return rootOption.children
  }
  else if (rootOption) {
    return options
  }
  for (const i in options) {
    if (options[i]?.children?.length) {
      const childDeepest = getDeepestActiveOptions(options[i].children!)
      if (childDeepest.length) {
        return childDeepest
      }
    }
  }
  return []
}

const rootCategoryList = computed<FilterOption[]>(() => {
  return getDeepestActiveOptions(props.filter.options) || []
})
</script>

<template>
  <div
    v-if="filter?.options?.length"
    class="filter-links"
  >
    <!--
    <h2 class="filter-links__title">
      {{ filter.label }}
    </h2>
    -->
    <UiScrollable
      class="filters-links__scrollable"
      axis="x"
    >
      <ul class="filter-links__list">
        <li class="filter-links__item filter-links__item--all">
          <span class="filter-links__current">
            {{ $t('All') }}
          </span>
        </li>
        <FilterLinksItem
          v-for="option in rootCategoryList"
          :key="option.key"
          :option="option"
          :filter="filter"
          class="filter-links__item"
        />
      </ul>
    </UiScrollable>

    <!-- <pre>filter: {{ filter }}</pre> -->
  </div>
</template>

<style>
@import url("~layers/app/components/Filter/Links.css");
</style>
